export const caregiverActivitiesMockData = [
  {
    activityId: 'ACT-001',
    caregiverId: 'STAFF-123',
    caregiverName: 'Nurse Sarah Collins',
    patientId: 'PT-1001',
    patientName: 'John Smith',
    activityType: 'Medication Administration',
    startTime: '2023-12-04T08:30:00',
    endTime: '2023-12-04T08:45:00',
    notes: 'Administered IV antibiotics as prescribed',
    caregiverFeedback: 'Patient tolerated medication well',
    department: 'General Surgery',
    roomNumber: 'A-201',
    status: 'Completed'
  },
  {
    activityId: 'ACT-002',
    caregiverId: 'STAFF-145',
    caregiverName: 'Nurse Michael Chen',
    patientId: 'PT-1023',
    patientName: 'Emma Wilson',
    activityType: 'Vital Signs Check',
    startTime: '2023-12-04T09:30:00',
    endTime: '2023-12-04T09:45:00',
    notes: 'BP 120/80, Temp 37.1°C, RR 18, HR 72, O2 Sat 98%',
    caregiverFeedback: 'Patient comfortable, showing improvement',
    department: 'Pulmonology',
    roomNumber: 'B-105',
    status: 'Completed'
  },
  {
    activityId: 'ACT-003',
    caregiverId: 'STAFF-167',
    caregiverName: 'Nurse Amanda Rodriguez',
    patientId: 'PT-1045',
    patientName: 'Michael Brown',
    activityType: 'Blood Glucose Monitoring',
    startTime: '2023-12-04T10:15:00',
    endTime: '2023-12-04T10:25:00',
    notes: 'Blood glucose level 145 mg/dL',
    caregiverFeedback: 'Patient needed reassurance during procedure',
    department: 'Endocrinology',
    roomNumber: 'C-310',
    status: 'Completed'
  },
  {
    activityId: 'ACT-004',
    caregiverId: 'STAFF-189',
    caregiverName: 'PT Daniel Morris',
    patientId: 'PT-1067',
    patientName: 'Jessica Lee',
    activityType: 'Physical Therapy',
    startTime: '2023-12-04T10:00:00',
    endTime: '2023-12-04T10:45:00',
    notes: 'Performed range-of-motion exercises, gait training',
    caregiverFeedback: 'Patient motivated, experiencing decreased pain',
    department: 'Orthopedics',
    roomNumber: 'D-112',
    status: 'Completed'
  },
  {
    activityId: 'ACT-005',
    caregiverId: 'STAFF-123',
    caregiverName: 'Nurse Sarah Collins',
    patientId: 'PT-1123',
    patientName: 'Sophia Martinez',
    activityType: 'IV Management',
    startTime: '2023-12-04T10:50:00',
    endTime: '2023-12-04T11:05:00',
    notes: 'Changed IV fluid bag, adjusted flow rate',
    caregiverFeedback: 'IV site clear, no signs of infiltration',
    department: 'Internal Medicine',
    roomNumber: 'B-202',
    status: 'Completed'
  },
  {
    activityId: 'ACT-006',
    caregiverId: 'STAFF-145',
    caregiverName: 'Nurse Michael Chen',
    patientId: 'PT-1178',
    patientName: 'Olivia Johnson',
    activityType: 'Pain Assessment',
    startTime: '2023-12-04T11:20:00',
    endTime: '2023-12-04T11:30:00',
    notes: 'Pain level 7/10, requesting medication',
    caregiverFeedback: 'Patient reports migraine worsening',
    department: 'Neurology',
    roomNumber: 'D-305',
    status: 'Completed'
  },
  {
    activityId: 'ACT-007',
    caregiverId: 'STAFF-210',
    caregiverName: 'Nurse David Chen',
    patientId: 'PT-1305',
    patientName: 'Robert Johnson',
    activityType: 'Ventilator Check',
    startTime: '2023-12-04T07:30:00',
    endTime: '2023-12-04T07:45:00',
    notes: 'Ventilator settings verified, all parameters within range',
    caregiverFeedback: 'Patient sedated, stable condition',
    department: 'ICU',
    roomNumber: 'D-001',
    status: 'Completed'
  },
  {
    activityId: 'ACT-008',
    caregiverId: 'STAFF-167',
    caregiverName: 'Nurse Amanda Rodriguez',
    patientId: 'PT-1201',
    patientName: 'William Taylor',
    activityType: 'Wound Assessment',
    startTime: '2023-12-04T11:45:00',
    endTime: '2023-12-04T12:00:00',
    notes: 'Surgical wound appears clean, no signs of infection',
    caregiverFeedback: 'Wound healing well, patient comfortable',
    department: 'General Surgery',
    roomNumber: 'A-215',
    status: 'Completed'
  },
  {
    activityId: 'ACT-009',
    caregiverId: 'STAFF-245',
    caregiverName: 'Nurse Jennifer Lopez',
    patientId: 'PT-1367',
    patientName: 'Patricia White',
    activityType: 'Medication Preparation',
    startTime: '2023-12-04T12:15:00',
    endTime: '2023-12-04T12:45:00',
    notes: 'Prepared chemotherapy drugs according to protocol',
    caregiverFeedback: 'Preparation completed, ready for administration',
    department: 'Oncology',
    roomNumber: 'A-301',
    status: 'Completed'
  },
  {
    activityId: 'ACT-010',
    caregiverId: 'STAFF-123',
    caregiverName: 'Nurse Sarah Collins',
    patientId: 'PT-1001',
    patientName: 'John Smith',
    activityType: 'Patient Education',
    startTime: '2023-12-04T12:30:00',
    endTime: '2023-12-04T13:00:00',
    notes: 'Provided instructions on post-operative care and limitations',
    caregiverFeedback: 'Patient understood instructions, had few questions',
    department: 'General Surgery',
    roomNumber: 'A-201',
    status: 'Completed'
  },
  {
    activityId: 'ACT-011',
    caregiverId: 'STAFF-189',
    caregiverName: 'PT Daniel Morris',
    patientId: 'PT-1067',
    patientName: 'Jessica Lee',
    activityType: 'Physical Therapy',
    startTime: '2023-12-04T15:30:00',
    endTime: null,
    notes: 'Scheduled afternoon therapy session',
    caregiverFeedback: '',
    department: 'Orthopedics',
    roomNumber: 'D-112',
    status: 'Scheduled'
  },
  {
    activityId: 'ACT-012',
    caregiverId: 'STAFF-245',
    caregiverName: 'Nurse Jennifer Lopez',
    patientId: 'PT-1367',
    patientName: 'Patricia White',
    activityType: 'Chemotherapy Administration',
    startTime: '2023-12-04T13:30:00',
    endTime: null,
    notes: 'Scheduled chemotherapy session',
    caregiverFeedback: '',
    department: 'Oncology',
    roomNumber: 'A-301',
    status: 'Scheduled'
  }
]
